import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../config/firebase";
import store from "../store";
import { setMetricsData } from "../store/slices/metricSlice";

// export const getMetrics = async () => {
//   try {
//     const docRef = doc(db, "metrics", "responses-object");
//     const docSnap = await getDoc(docRef);
//     if (docSnap.exists()) {
//       store.dispatch(setMetricsData(docSnap.data()));
//       console.log(docSnap.data());
//     } else {
//       console.log("No document found");
//     }
//     return true;
//   } catch (error) {
//     console.log("Get Metrics Error:", error.message);
//   }
// };

export const getMetrics = async (payload) => {
  try {
    const q = query(
      collection(db, "newMetrics"),
      where("createdAt", ">=", payload?.start),
      where("createdAt", "<=", payload?.end)
    );
    const querySnapshot = await getDocs(q);
    const data = {
      callResponse: 0,
      smsResponse: 0,
      emailResponse: 0,
      shareResponse: 0,
      androidResponse: 0,
      iosResponse: 0,
      desktopResponse: 0,
    };

    querySnapshot.forEach((doc) => {
      const docData = doc.data();
      if (docData.type === "callResponse") data.callResponse++;
      if (docData.type === "smsResponse") data.smsResponse++;
      if (docData.type === "emailResponse") data.emailResponse++;
      if (docData.type === "shareResponse") data.shareResponse++;
      if (docData.type === "androidResponse") data.androidResponse++;
      if (docData.type === "iosResponse") data.iosResponse++;
      if (docData.type === "desktopResponse") data.desktopResponse++;
    });
    store.dispatch(setMetricsData(data));
    return data;
  } catch (error) {
    console.log("Get Metrics Error:", error.message);
    return null; // Returning null in case of an error
  }
};
